import { useAuthentication, withAuthenticationContext } from '@psyomics/ui-common';
import { Navigate } from 'react-router-dom';

import { ReferralUploadJobs as ReferralUploadJobsFeature } from '../../../features/referral-upload-jobs/referral-upload-jobs';

const ReferralUploadJobsWithContext = withAuthenticationContext(ReferralUploadJobsFeature);

const ReferralUploadJobs = () => {
  const { bulkReferralEnabled, organisation } = useAuthentication();

  if (!bulkReferralEnabled) {
    return <Navigate replace to={`/account/${organisation}/home`} />;
  }

  return <ReferralUploadJobsWithContext />;
};

export { ReferralUploadJobs };
